export default __webpack_public_path__ + "static/media/donut-orbit.6ea3d26f.png";